<template>
  <div class="publisher"></div>
</template>

<script>
import OT from "@opentok/client";
import { Widget } from "@/components/services/participant-service";
export default {
  name: "telehealth-publisher",
  props: {
    session: {
      type: OT.Session,
      required: false
    },
    opts: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      widget: new Widget()
    };
  },
  mounted: function() {
    const publisher = OT.initPublisher(this.$el, this.opts, err => {
      if (err) {
        this.$emit("error", err);
      } else {
        this.$emit("publisherCompleted");
      }
    });
    this.$emit("publisherCreated", publisher);
    const publish = () => {
      this.session.publish(publisher, err => {
        if (err) {
          this.$emit("error", err);
        } else {
          this.$emit("publisherConnected", publisher);
        }
      });
    };
    if (this.session && this.session.isConnected()) {
      publish();
    }
    if (this.session) {
      this.session.on("sessionConnected", publish);
    }
    publisher.on("accessDenied", function() {
      const widget = new Widget();
      const message = widget.translate("please_enable_camera_and_microphone_permissions", "Please enable Camera and Microphone permissions.");
      if (message) {
        this.$toastr.success(message);
      }
    });
  }
};
</script>
